import type { JqlValidation } from '@tasks/contracts';

import { apiRequest } from './client';

export type ValidateJqlResult = JqlValidation;

export function validateJql(jql: string, signal?: AbortSignal): Promise<JqlValidation> {
  return apiRequest<JqlValidation>('/jql/validate', { method: 'POST', body: { jql }, signal });
}
